import { useEffect } from 'react';
import { SelectAllHotkeys } from 'src/components/common/MultiSelect/Toggle/contants';
import { MultiSelectionToggle } from 'src/components/common/MultiSelect/Toggle/MultiSelectionToggle';
import { useCommandMenuContext } from 'src/contexts/CommandMenuContext/CommandMenuContext';
import {
  MultiSelectScope,
  useMultiSelectionContext,
} from 'src/contexts/MultiSelectionContext';
import { PosHotkeys } from 'src/core/POS/PosHotkeys';
import { CommandOptionType } from 'src/WebApiController';

interface MultiSelectionToggleGroupProps {
  groupId: string;
  onToggle?: (groupId: string, isChecked: boolean) => void;
  enableHotkey?: boolean;
  variant?: 'button' | 'checkbox';
}

export const MultiSelectionToggleGroup = ({
  groupId,
  onToggle,
  variant = 'checkbox',
  enableHotkey = false,
}: MultiSelectionToggleGroupProps) => {
  const { selectionMode, setSelectionMode, getSelection } =
    useMultiSelectionContext();
  const listingSelection = getSelection(groupId);
  const isChecked = selectionMode?.groupId === groupId;
  const { registerCommand, unregisterCommand } = useCommandMenuContext();

  const onSelectMultipleClick = (e?: React.MouseEvent) => {
    e?.stopPropagation();
    onToggle?.(groupId, isChecked);

    if (listingSelection.isSingleGroupMultiSelect) {
      setSelectionMode();
    } else {
      setSelectionMode({
        mode: MultiSelectScope.SingleGroup,
        groupId,
      });
    }
  };

  // Since hotkeys are shared with globalToggle, disabled the hotkey
  // in here will make the global to be disabled too.
  const keyNames = enableHotkey ? SelectAllHotkeys : '';

  useEffect(() => {
    registerCommand({
      command: {
        id: CommandOptionType.ToggleSelectionMode,
        onSelect: () => {
          if (listingSelection.isSingleGroupMultiSelect) {
            setSelectionMode();
          } else {
            setSelectionMode({
              mode: MultiSelectScope.SingleGroup,
              groupId,
            });
          }
        },
      },
    });

    return () => {
      unregisterCommand({ commandId: CommandOptionType.ToggleSelectionMode });
    };
  }, [
    unregisterCommand,
    registerCommand,
    setSelectionMode,
    listingSelection.isSingleGroupMultiSelect,
    groupId,
  ]);

  return (
    <PosHotkeys
      keyNames={keyNames}
      onHotkeyActivated={(_keyName, _event) => {
        onSelectMultipleClick();
      }}
      disabled={!enableHotkey}
    >
      <MultiSelectionToggle
        onChange={onSelectMultipleClick}
        isToggled={isChecked}
        variant={variant}
      />
    </PosHotkeys>
  );
};
